import {
  BillingStatusLabelsKeys,
  ReservationStatusLabelsKeys,
  UpdatedByLabelsKeys,
  UploadImagesProps,
  CallMethodNames,
  SettlementNameProps,
  DepartmentListItemProps,
  PharmacyProps,
  VerificationTypes,
  CallMethodLabels,
} from './common'
import { PrescriptionType } from './med'
import i18n from 'i18next'

export type ReceptionApiProps = {
  institution_access_key: string
  provisional_reservation_access_key?: string
  company_key?: string
  pharmacy?: string
  sld_token?: string
}

export type ReceptionEmailSendFormProps = {
  email: string
}

export type ReceptionEmailSendProps = ReceptionEmailSendFormProps &
  ReceptionApiProps

export type ReceptionSmsSendFormProps = {
  phone: string
}

export type ReceptionSmsSendProps = ReceptionSmsSendFormProps &
  ReceptionApiProps

export type MedicalInstitutionProps = {
  name: string
  departments: Array<DepartmentListItemProps>
  prefecture: string
  city: string
  town: string
  street: string
  building: string | null
  online_eligibility_verification_url: string | null
}

export type StripeSettingProps = {
  public_key: string
  client_secret: string
  payment_method_id: string | null
  connect_account_id: string
}

export type HowToReceiveMedicineKeys = 'visit' | 'delivery'
export type ConsultationMethod = 'online' | 'in_person'
export const consultationMethodNames: {
  [key in ConsultationMethod]: string
} = {
  online: i18n.t('オンライン'),
  in_person: i18n.t('対面（予約時間に来院）'),
}

export type PharmacyServiceType =
  | 'todokusuri'
  | 'tayoris_health_management_support'

export type ReservationFormProps = {
  id?: number
  access_key?: string
  applicant_email?: string
  free_description?: string
  call_method?: CallMethodNames | null
  consultation_method?: ConsultationMethod | null
  reservation_message?: string
  applicant_first_name?: string
  applicant_last_name?: string
  applicant_first_name_kana?: string
  applicant_last_name_kana?: string
  applicant_birthday?: string
  applicant_phone: string
  applicant_postal_code?: string
  applicant_address?: string
  registration_card_number?: string
  settlement_method?: SettlementNameProps
  saves_data?: boolean
  credit_name?: string // NOTE: frontend内部でしか利用されないフィールド
  how_to_receive_medicine?: HowToReceiveMedicineKeys
  prescription_medicine?: PrescriptionType
  pharmacy_service?: PharmacyServiceType
  verification_type: VerificationTypes
  pass_code?: string
  reservation_department_id?: number
  reservation_department_name?: string
  reservation_datetime_start?: string
  reservation_datetime_end?: string
  reservation_number?: string
  status?: ReservationStatusLabelsKeys
  call_method_label?: CallMethodLabels
  settlement_method_label?: string
  settlement_status?: BillingStatusLabelsKeys
  pharmacy?: PharmacyProps
  scuel_id?: string
  online_eligibility_verification_agreed?: boolean
  is_phr_integration?: boolean
  insurance_card_type?: 'insurance_card' | 'my_number_insurance' | null
  created_at?: string
  updated_at?: string
  updated_by?: UpdatedByLabelsKeys
} & UploadImagesProps

export type ReservedReservationProps = ReservationFormProps & {
  applicant_email: string
  access_key: string
  reservation_department_id: number
  scuel_id: undefined // GETデータには存在しない仕様のため削除
}

export type PasscodeEntryApiProps = {
  reservation_number?: string
  expiration: string
  is_canceled: boolean
}

export const PersonalSettlementsNames: {
  [key in SettlementNameProps]:
    | 'クレジットカード'
    | '銀行振込'
    | '代金引換'
    | '対面時窓口'
    | '自己負担なし'
} = {
  credit_card: 'クレジットカード',
  link: 'クレジットカード',
  bank_transfer: '銀行振込',
  cod: '代金引換',
  next_visit: '対面時窓口',
  no_charge: '自己負担なし',
}

export type EligibilityVerificationAppIdParams = {
  online_eligibility_verification_app_id: string
}

export type EligibilityVerificationUrlSettingProps = {
  url?: string | null
  appId?: string
}

export type InsuranceType = 'not_use' | 'insurance_card' | 'my_number_insurance'
